import { OktaAuth } from '@okta/okta-auth-js';
import { getConfig } from '../config/loader';

let instance: OktaAuth | null = null;

export function getOktaAuth(): OktaAuth {
    if (instance) {
        return instance;
    }

    const config = getConfig();

    instance = new OktaAuth({
        issuer: config.OKTA_ISSUER,
        clientId: config.OKTA_CLIENT_ID,
        redirectUri: config.OKTA_REDIRECT_URI,
        postLogoutRedirectUri: config.OKTA_POST_LOGOUT_REDIRECT_URI,
        scopes: ['openid', 'profile', 'email', 'dvms-ui-groups'],
        pkce: true,
        tokenManager: {
            autoRenew: true,
            autoRemove: true,
        },
    });

    return instance;
}
